<button (click)="openFeedbackDialog()" color="primary" mat-raised-button>Stuur feedback</button>

<ng-template #feedbackDialog>
  <h1 mat-dialog-title>Feedback sturen</h1>
  <mat-dialog-content>
    <mat-form-field>
      <textarea matInput placeholder="Typ hier je feedback" rows="20" [(ngModel)]="feedback.message"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Annuleren</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="feedback.message" [disabled]="feedback.message === ''">Insturen</button>
  </mat-dialog-actions>
</ng-template>